import Nav from "@/components/itly/Nav";
import Hero from "@/components/itly/Hero";
import WhyPartner from "@/components/itly/WhyPartner";
import ForWho from "@/components/itly/ForWho";
import ComparisonSection from "@/components/itly/ComparisonSection";
import CommissionCalculator from "@/components/itly/CommissionCalculator";
import PartnerPhoneDemo from "@/components/itly/PartnerPhoneDemo";
import HowItWorks from "@/components/itly/HowItWorks";
import PlatformRules from "@/components/itly/PlatformRules";
import RegionTicker from "@/components/itly/RegionTicker";
import RegisterForm from "@/components/itly/RegisterForm";
import FAQ from "@/components/itly/FAQ";
import Footer from "@/components/itly/Footer";
import CursorSpark from "@/components/itly/CursorSpark";
import SectionNav from "@/components/itly/SectionNav";
import { useScrollReveal } from "@/hooks/useScrollReveal";
import { useTrackPageView } from "@/hooks/useAnalytics";

const SECTIONS = [
    { id: "visione", labelKey: "sections.start" },
    { id: "perche", labelKey: "sections.why" },
    { id: "per-chi", labelKey: "sections.forWho" },
    { id: "app-preview", labelKey: "sections.demo" },
    { id: "commissione", labelKey: "sections.commission" },
    { id: "come-funziona", labelKey: "sections.howItWorks" },
    { id: "regole", labelKey: "sections.rules" },
    { id: "faq", labelKey: "sections.faq" },
    { id: "candidati", labelKey: "sections.apply" },
];

export default function HomePartner() {
    useScrollReveal();
    useTrackPageView("/partner");
    return (
        <div data-testid="home-page" className="itly-page-root" style={{ background: "var(--itly-page)", minHeight: "100vh" }}>
            <CursorSpark />
            <Nav />
            <SectionNav items={SECTIONS} />
            <Hero />
            <WhyPartner />
            <ForWho />
            <PartnerPhoneDemo />
            <CommissionCalculator />
            <HowItWorks />
            <PlatformRules />
            <ComparisonSection />
            <RegionTicker />
            <FAQ />
            <RegisterForm />
            <Footer />
        </div>
    );
}
